import intersection from "lodash/intersection";
import { SharedFileRequestContextType } from "@wingspanhq/shared-files/dist/lib/interfaces/sharedFileRequest";
import flatten from "lodash/flatten";

export const selectorIsContextTypesMatched = (
  sharedFileSettings?: { contextType?: SharedFileRequestContextType },
  contextTypes?: SharedFileRequestContextType | SharedFileRequestContextType[]
) => {
  return (
    intersection([sharedFileSettings?.contextType], flatten([contextTypes]))
      .length > 0
  );
};
